
import { defineComponent, PropType, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { GatewayRouteT } from '@/core/types/gateway.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<GatewayRouteT>,
            default: null,
        },
    },
    emits: ['update', 'delete', 'bind'],
    setup(props, { emit }) {
        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const emitDelete = () => {
            emit('delete', toRaw(props.item))
        }

        const emitBind = () => {
          emit('bind', toRaw(props.item))
        }

        return { emitUpdate, emitDelete, emitBind }
    },
})
